import {useQuery} from '@tanstack/react-query';

import {useEmissionsQuery} from '../../query/graphql';
import {FCT_SCENARIOS} from '../decision/data/fctScenarios';
import {CurrentScenarioId, FctScenario, TargetScenarioId} from '../decision/fctCalculator.types';

export function useScenarioEmissions(scenarioId?: CurrentScenarioId | TargetScenarioId) {
  return useQuery<number | null>({
    queryKey: ['useScenarioEmissions', scenarioId],
    queryFn: async () => {
      if (!scenarioId) return null;
      return await fetchScenarioEmissions(FCT_SCENARIOS[scenarioId]);
    },
  });
}

async function fetchScenarioEmissions(scenario: FctScenario) {
  const emissions = await Promise.all(
    scenario.inputSets.map(set => useEmissionsQuery.fetcher({endpoint: set.endpoint, inputs: set.inputs})())
  );
  return emissions.reduce((acc, result) => acc + result.emissions.emissions, 0);
}
